import { createStyles } from '@material-ui/core';
import type { Theme } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    headerNav: {
      display: 'grid',
      gridArea: 'nav',
      gridAutoFlow: 'column',
      gridColumnStart: 3,

      // ie hacks
      '-ms-grid-row-align': 'center',
      '-ms-grid-column': 3,

      '@media (max-width: 991px)': {
        display: 'none',
        gridAutoFlow: 'row',
        background: theme.primary,

        '&$open': {
          display: 'grid',
          '-ms-grid-rows': '1fr[3]',
          gridColumnStart: 1,
          '-ms-grid-column': 1,
          gridColumnEnd: 'span 3',
          '-ms-grid-column-span': '3',
          gridRowStart: 2,
          '-ms-grid-row': '2'
        },
        '& $navButton': {
          // TODO: FIX FOR SMALL IE Screens
          '@media (max-width: 992px)': {
            gridColumnStart: 3
          }
        }
      }
    },
    open: {},
    hasPackages: {}
  });

export default styles;
